import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, Currency, FormatNumber, config, UserCode } from '../components/Include';
import { Alerts } from '../components/notify';
import { getBritishDate } from '../components/GlobalFunction';
import { useSelector } from 'react-redux'
import './invoice.css';

const Invoice = () => {
  const [invoice, setInvoice] = useState([] as any);
  const [loading, setLoading] = useState(true);
  const [currentDate] = useState(new Date());

  const steps = useSelector((state:any) => state.rootReducer.steps);
  const student = useSelector((state:any) => state.rootReducer.student);
  
  // Add class to body for white background
  useEffect(() => {
    document.body.classList.add('invoice-page');
    return () => {
      document.body.classList.remove('invoice-page');
    };
  }, []);
  
  const FetchSchedule = () => {
    setLoading(true);
    const url = API_URL + '/student/training/' + UserCode;
    
    axios.get(url, config)
      .then((response:any) => {
        if (response.data.status === 200) {
          setInvoice(response.data.data);
        }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Generate a QR code URL for verification
  const generateQRCode = (data: string) => {
    const qrData = encodeURIComponent(`EDC Registration: ${data}`);
    return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrData}`;
  };

  // Format date for display
  const formatDate = (dateString: string) => {
    return getBritishDate(dateString);
  };
  
  // Handle print action
  const handlePrint = () => {
    window.print();
  };
  
  // Handle download as PDF
  const handleDownload = () => {
    window.print(); // Simplified for now, could be enhanced with actual PDF generation
  };

  useEffect(() => {
    FetchSchedule();
  }, []);
  
  return (
    <div className="invoice-wrapper">
      {loading ? (
        <div className='overlay'>
          <img src="/images/loader.svg" alt="loader" />
        </div>
      ) : (
        invoice && invoice.map((list: any, id: number) => (
          <div key={id} className="invoice-container">
            {/* Invoice Content */}
            <div className="invoice-content">
              {/* Logo and Institution */}
              <div className="invoice-logo">
                <img src="/images/edc.png" alt="EDC Logo" className="img-fluid" />
                <h4>Entrepreneurship Development Center</h4>
                <h4>Nasarawa State University, Keffi</h4>
                <h5>Office of the Director</h5>
              </div>

              {/* Registration Title */}
              <h3 className="invoice-title">REGISTRATION SLIP</h3>

              {/* Registration Details */}
              <div className="invoice-details">
                {/* Amount Paid */}
                <div className="invoice-amount">
                  {Currency + FormatNumber(list.amount_paid)}
                </div>

                {/* Details Table */}
                <table className="invoice-table">
                  <tbody>
                    <tr>
                      <td>Registration Date</td>
                      <td>{formatDate(currentDate.toISOString().split('T')[0])}</td>
                    </tr>
                    <tr>
                      <td>Payment Reference</td>
                      <td>{list.payment_ref}</td>
                    </tr>
                    <tr>
                      <td>Student Name</td>
                      <td>{list.full_name}</td>
                    </tr>
                    <tr>
                      <td>Matric Number</td>
                      <td>{list.matric_no}</td>
                    </tr>
                    <tr>
                      <td>Skill Selected</td>
                      <td>{list.title}</td>
                    </tr>
                    <tr>
                      <td>Training Period</td>
                      <td>{formatDate(list.start_date)} - {formatDate(list.end_date)}</td>
                    </tr>
                    <tr>
                      <td>Level</td>
                      <td>{list.level}</td>
                    </tr>
                    <tr>
                      <td>Program</td>
                      <td>{list.department}</td>
                    </tr>
                    <tr>
                      <td>Session</td>
                      <td>{student?.session || 'Current Session'}</td>
                    </tr>
                    <tr>
                      <td>Training Location</td>
                      <td>Entrepreneurship Development Center, NSUK</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* QR Code for Verification */}
              <div className="invoice-qr">
                <img src={generateQRCode(list.payment_ref)} alt="Verification QR Code" />
                <p>Scan to verify registration</p>
              </div>

              {/* Verification Status */}
              <div className="invoice-verification">
                <i className="fa fa-check-circle"></i>
                <p>Payment verified and confirmed</p>
              </div>

              {/* Footer */}
              <div className="invoice-footer">
                <p>This registration slip serves as proof of payment and skill selection. Please keep it safe and present it when required.</p>
                <p><strong>Note:</strong> Training schedule and additional information will be provided at the center.</p>
                
                {/* Action Buttons */}
                <div className="invoice-actions no-print">
                  <button 
                    type="button" 
                    onClick={handlePrint} 
                    className="invoice-btn invoice-btn-print"
                  >
                    <i className="fa fa-print"></i> Print Registration Slip
                  </button>
                  <button 
                    type="button" 
                    onClick={handleDownload} 
                    className="invoice-btn invoice-btn-download"
                  >
                    <i className="fa fa-download"></i> Download as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Invoice;